module.exports = __webpack_public_path__ + "static/media/radio-off.45f6af34.svg";